import { backendToInputFormat, inputToBackendFormat } from '@shared/utils/date';

export interface DateFormatResult {
  inputValue: string;
  backendValue: string;
}

/**
 * Processes a value coming from the form/backend
 * Converts backend format (MM/dd/yyyy) to input format (yyyy-MM-dd)
 *
 * @param value - Date string in backend format or empty
 * @returns Object with both input and backend formatted values
 */
export const proccessWriteValue = (
  value: string | null | undefined,
): DateFormatResult => {
  if (!value) {
    return {
      inputValue: '',
      backendValue: '',
    };
  }

  return {
    inputValue: backendToInputFormat(value),
    backendValue: value,
  };
};

/**
 * Processes a date change from the input field
 * Validates year and converts input format (yyyy-MM-dd) to backend format (MM/dd/yyyy)
 *
 * @param inputValue - Date string in HTML5 input format
 * @returns Object with validated input value and converted backend value
 */
export const processDateChange = (inputValue: string): DateFormatResult => {
  let validatedInputValue = inputValue;

  if (inputValue) {
    const date = new Date(inputValue);
    const year = date.getFullYear();

    // Prevent years greater than 9999
    if (year > 9999) {
      const [yearStr, month, day] = inputValue.split('-');
      validatedInputValue = `${yearStr.slice(0, 4)}-${month}-${day}`;
    }
  }

  const backendValue = validatedInputValue
    ? inputToBackendFormat(validatedInputValue)
    : '';

  return {
    inputValue: validatedInputValue,
    backendValue,
  };
};
